/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZoomExclamation = createReactComponent("zoom-exclamation", "IconZoomExclamation", [
  ["path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  ["path", { d: "M21 21l-6 -6", key: "svg-1" }],
  ["path", { d: "M10 13v.01", key: "svg-2" }],
  ["path", { d: "M10 7v3", key: "svg-3" }]
]);

export { IconZoomExclamation as default };
//# sourceMappingURL=IconZoomExclamation.js.map
